import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Photos from "@/pages/Photos";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/photos" element={<Photos />} />
        <Route path="/photos/:albumSlug" element={<Photos />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.12)", color: "#fff" } }}
      />
    </BrowserRouter>
  );
}

export default App;
